import { render, staticRenderFns } from "./AppContainer.vue?vue&type=template&id=047bf0fc&scoped=true"
import script from "./AppContainer.vue?vue&type=script&lang=ts"
export * from "./AppContainer.vue?vue&type=script&lang=ts"
import style0 from "./AppContainer.vue?vue&type=style&index=0&id=047bf0fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bf0fc",
  null
  
)

export default component.exports